import React from 'react';

/**
 * Badge - Status indicator
 * FLO Design System v2
 */

const variantStyles = {
  success: 'bg-green-50 text-green-700 border-green-200',
  success_strong: 'bg-green-600 text-white border-green-600',
  warning: 'bg-amber-50 text-amber-700 border-amber-200',
  error: 'bg-red-50 text-red-700 border-red-200',
  info: 'bg-blue-50 text-blue-700 border-blue-200',
  neutral: 'bg-gray-50 text-gray-600 border-gray-200'
};

export const Badge = ({ children, variant = 'neutral', small = false }) => {
  return (
    <span className={`
      inline-flex items-center
      ${small ? 'px-1.5 py-0.5 text-xs' : 'px-2 py-0.5 text-xs'}
      font-medium
      border rounded
      ${variantStyles[variant]}
    `}>
      {children}
    </span>
  );
};

export default Badge;
